const state = {
  list: [],
}

const mutations = {
  ADD_ITEM_TO_LIST (state, payload) {
    state.list.push(payload)
  },
  REMOVE_ITEM_FROM_LIST (state, index) {
    state.list.splice(index, 1)
  },
  SET_LIST_ITEMS (state, payload) {
    state.list = payload
  },
  CLEAR_LIST_ITEMS (state) {
    state.list = []
  },
}

const actions = {
  addItemToList ({ commit }, payload) {
    commit('ADD_ITEM_TO_LIST', payload)
  },
  removeItemFromList ({ commit }, payload) {
    commit('REMOVE_ITEM_FROM_LIST', payload)
  },
  setListItems ({ commit }, payload) {
    commit('SET_LIST_ITEMS', payload)
  },
  clearListItems ({ commit }) {
    commit('CLEAR_LIST_ITEMS')
  },
}

const getters = {
  getDataToSend (state) {
    const excluded = ['expense_category']
    return state.list.map(item => Object.keys(item)
      .filter(key => !excluded.includes(key))
      .reduce((result, key) => {
        result[key] = item[key]
        return result
      }, {}))
  },
}

export default {
  namespaced: true,
  strict: true,
  state,
  mutations,
  actions,
  getters,
}
